import { Auth } from "@lib/authentication";
import { parseAuthResult } from "@lib/authentication/amplify/amplify.helpers";

import { omgApiClient } from "./omgApiClient";

export type UserPreferences = {
  explicitContent: boolean;
  explicitEligible: boolean;
  explicitOverlayShown: boolean;
};

// `explicitEligible` is set by signup/admin only — never by the user themselves.
export type UpdateUserPreferences = Partial<
  Pick<UserPreferences, "explicitContent" | "explicitOverlayShown">
>;

const authHeader = async (): Promise<Record<string, string>> => {
  const { accessToken } = parseAuthResult(
    await Auth.currentAuthenticatedUser(),
  );
  return { Authorization: `Bearer ${accessToken?.jwt}` };
};

export const fetchUserPreferences = async (): Promise<UserPreferences> => {
  const response = await omgApiClient.get<UserPreferences>(
    "/user-preferences",
    {
      headers: await authHeader(),
    },
  );
  return response.data;
};

export const updateUserPreferences = async (
  patch: UpdateUserPreferences,
): Promise<UserPreferences> => {
  const response = await omgApiClient.patch<UserPreferences>(
    "/user-preferences",
    patch,
    { headers: await authHeader() },
  );
  return response.data;
};
